export default "__VITE_PUBLIC_ASSET__12259f24__"